import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import ValidatorBox from './ValidatorBox'
import Flex from '../Flex'

const MIN_LENGTH = 8

const hasLowerCase = (str) => {
    return (/[a-z]/.test(str))
}

const hasUpperCase = (str) => {
    return (/[A-Z]/.test(str))
}

const hasNumbers = (str) => {
    return (/[0-9]/.test(str))
}

export const hasSpecialCharacter = (str) => {
    return (/[^0-9A-Za-z]/.test(str))
}

const PasswordValidators = ({ password, setIsValidPassword, ...restProps }) => {
    const isValidLength = password.length >= MIN_LENGTH
    const isValidLowerCase = hasLowerCase(password)
    const isValidUpperCase = hasUpperCase(password)
    const isValidNumbers = hasNumbers(password)
    const isValidSpecialCharacter = hasSpecialCharacter(password)

    useEffect(() => {
        password && setIsValidPassword(isValidLength && isValidLowerCase && isValidUpperCase && isValidNumbers && isValidSpecialCharacter)
    }, [password, setIsValidPassword, isValidLength, isValidLowerCase, isValidUpperCase, isValidNumbers])

    return (
        <Flex flexWrap='wrap' flexDirection='row' >
            <ValidatorBox {...restProps} valid={isValidLength} typeValidationText={<FormattedMessage id='validator-box-length' defaultMessage='Al menos 8 caracteres' />} />
            <ValidatorBox {...restProps} valid={isValidLowerCase} typeValidationText={<FormattedMessage id='validator-box-lowecase' defaultMessage='Minúsculas' />} />
            <ValidatorBox {...restProps} valid={isValidUpperCase} typeValidationText={<FormattedMessage id='validator-box-uppercase' defaultMessage='Mayúsculas' />} />
            <ValidatorBox {...restProps} valid={isValidNumbers} typeValidationText={<FormattedMessage id='validator-box-numbers' defaultMessage='Números' />} />
            <ValidatorBox {...restProps} valid={isValidSpecialCharacter} typeValidationText={<FormattedMessage id='validator-special-character' defaultMessage='Un carácter especial' />} />
        </Flex>
    )
}

PasswordValidators.propTypes = {
    password: PropTypes.string,
    setIsValidPassword: PropTypes.func,
    fontWeight: PropTypes.any,
    fontSize: PropTypes.any,
    padding: PropTypes.any,
}

PasswordValidators.defaultProps = {
    fontWeight: 'regular',
    fontSize: 'xSmall',
    padding: '6px 12px',
}

export default PasswordValidators
